import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { makeStyles } from '@material-ui/styles'
import { Link as RouterLink } from 'react-router-dom'
import { Card, CardContent, Typography, Divider, Link } from '@material-ui/core'
import { Page } from 'components'
import { Logo } from 'components/Logo'
import { pxToRem } from 'utils/helpers'
import { ButtonWithLoading } from 'components/ButtonWithLoading'
import constants from 'utils/constants'
import { useExameRealizadoService } from 'hooks/useExameRealizadoService'
import { useExameSolicitadoService } from 'hooks/useExameSolicitadoService'
import { useVestigioService } from 'hooks/useVestigioService'
import { useParams } from 'react-router'

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  card: {
    width: theme.breakpoints.values.sd,
    maxWidth: pxToRem(480),
    minWidth: pxToRem(480),
    overflow: 'unset',
    display: 'flex',
    position: 'relative',
    '& > *': {
      flexGrow: 1,
      flexBasis: '50%',
      width: '50%',
    },
  },
  content: {
    padding: theme.spacing(8, 4, 3, 4),
  },
  media: {
    borderTopRightRadius: 4,
    borderBottomRightRadius: 4,
    padding: theme.spacing(3),
    color: theme.palette.white,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  profile: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    minHeight: 'fit-content',
  },
  form: {
    marginTop: theme.spacing(3),
  },
  divider: {
    margin: theme.spacing(2, 0),
  },
}))

export const DocumentoValidado = () => {
  const classes = useStyles()
  const params = useParams()
  const exameRealizadoService = useExameRealizadoService()
  const exameSolicitadoService = useExameSolicitadoService()
  const vestigioService = useVestigioService()
  const documentoValidado = useSelector((state) => state.pdf)
  const [isDownloadingPDF, setIsDownloadingPDF] = useState(false)

  const handleDownloadPDF = () => {
    if (params.tipoDocumento === 'EXAME_SOLICITADO') {
      exameSolicitadoService.downloadPDFDocumentoExameSolicitado(documentoValidado.idExameSolicitado)
    } else if(params.tipoDocumento === 'TERMO_NAO_CONFORMIDADE'){
      vestigioService.downloadPDFTermoNaoConformidade(documentoValidado.idTermo)
    }else{
      exameRealizadoService.downloadArquivoDocumento(documentoValidado.idExameRealizado, documentoValidado.dados.numeroExame, setIsDownloadingPDF, params.tipoDocumento)
    }
  }

  return (
    <Page className={classes.root} title="Validação de documentos">
      <Card className={classes.card}>
        <CardContent className={classes.content}>
          <div className={classes.profile}>
            <Logo />
            <Typography gutterBottom variant="h4">
              Validação de documentos
            </Typography>

            <Divider className={classes.divider} />

            {params.tipoDocumento === 'EXAME_SOLICITADO' && (
              <Typography align="center" gutterBottom variant="h5">
                {!documentoValidado.dados.codigoValidacao || documentoValidado.documentoInvalido ? `O código inserido não é válido.` : `o código inserido corresponde a um documento de solicitação válido`}
              </Typography>
            )}
            {params.tipoDocumento === 'EXAME_REALIZADO' && (
              <Typography align="center" gutterBottom variant="h5">
                {!documentoValidado.dados.codigoValidacao || documentoValidado.documentoInvalido
                  ? `O código inserido não é válido.`
                  : `O código inserido corresponde ao
                ${constants.LABEL_EXAMES_REALIZADOS[documentoValidado.dados.tipoExame]}, identificador
                ${documentoValidado.dados.numeroExame}.`}
              </Typography>
            )}
          </div>
          <ButtonWithLoading
            className={classes.submitButton}
            color="secondary"
            isDisabled={!documentoValidado.dados.codigoValidacao || documentoValidado.documentoInvalido}
            size="large"
            type="submit"
            variant="contained"
            label="Download cópia"
            isLoading={isDownloadingPDF}
            onClick={handleDownloadPDF}
          />
          <Divider className={classes.divider} />
          <Link align="center" color="secondary" component={RouterLink} to="/publico/validar-documento" underline="always" variant="subtitle2">
            Validar outro documento
          </Link>
        </CardContent>
      </Card>
    </Page>
  )
}
